<template>
  <div class="h-screen flex w-full vx-row no-gutter items-center justify-center d-theme-dark-bg" id="page-unauthorized">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card class="unauth-card d-theme-dark-light-bg d-theme-border-grey-light">
        <div slot="no-body" class="d-theme-dark-light-bg">
          <div class="vx-row no-gutter justify-center items-center d-theme-dark-light-bg">
            <div class="vx-col hidden lg:block lg:w-1/2 flex items-center justify-center p-6 unauth-logo-col">
              <img src="@/assets/images/logo/itatlogowide.png" alt="ITAT" class="unauth-logo">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 unauth-content-col">
              <div class="p-8">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4 d-theme-text-inverse">This account is unauthorized to use ITAT Time Tracker</h4>
                  <p class="d-theme-text-inverse">Please request an ITAT member add you to the whitelist and ensure that your email is verified</p>
                </div>
                <div class="mt-4">
                  <vs-button @click="ReturnToSignIn" color="primary">Return to Sign In</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    document.title = 'ITAT Time Tracker - Unauthorized'
  },
  methods: {
    ReturnToSignIn() {
      this.$auth.logout({
        logoutParams: { returnTo: window.location.origin }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#page-unauthorized {
  ::v-deep .unauth-card {
    border-radius: 0.5rem;
    overflow: hidden;
  }
  .unauth-logo {
    max-width: 100%;
    height: auto;
    max-height: 80px;
  }
}
</style>
